import React from 'react';
import { Typography, Grid, Autocomplete, Box, TextField } from '@mui/material';
import { HrSimulationOfficialGrade, AgentGrade } from '../helpers/types';
import { StyLoadingSkeleton, StyBlock } from './StyledComponents';
import { useTranslation } from 'react-i18next';

const GradeSelect = ({
    isLoading,
    agentGrade,
    hrSimulationOfficialGradeData,
    grade,
    onGradeChange,
    onEchelonChange,
    onChanges,
    isUpdateEnabled,
}: {
    onChanges: (hasGradeChanges: boolean) => void;
    grade: string;
    onGradeChange: (grade: string) => void;
    onEchelonChange: (echelon: string) => void;
    agentGrade: AgentGrade;
    hrSimulationOfficialGradeData: HrSimulationOfficialGrade[];
    isLoading: boolean;
    isUpdateEnabled: boolean;
}): React.ReactElement => {
    const { t } = useTranslation();
    const sortedGradeData = hrSimulationOfficialGradeData.sort((a, b) =>
        a.filiere.localeCompare(b.filiere),
    );
    return (
        <StyBlock>
            <Typography variant="h5" color="primary">
                {t('humanResources.simulation.gradeHypothesis.grade')}
            </Typography>
            <Grid container spacing={4}>
                <Grid item xs={6}>
                    <Box>
                        <Typography variant="body1" color="#bdbdbd">
                            {t(
                                'humanResources.simulation.gradeHypothesis.currentGrade',
                            )}
                        </Typography>
                        {isLoading ? (
                            <StyLoadingSkeleton height="5em" />
                        ) : (
                            <TextField
                                variant="outlined"
                                value={agentGrade.grade}
                                sx={{
                                    backgroundColor: 'white',
                                    width: '100%',
                                    marginTop: '5px',
                                }}
                                disabled
                            />
                        )}
                    </Box>
                </Grid>
                <Grid item xs={6}>
                    <Box>
                        <Typography variant="body1">
                            {t(
                                'humanResources.simulation.gradeHypothesis.newGrade',
                            )}
                        </Typography>
                        {isLoading ? (
                            <StyLoadingSkeleton height="5em" />
                        ) : (
                            <Autocomplete
                                id="grade-select"
                                options={sortedGradeData}
                                groupBy={(option) => option.filiere}
                                getOptionLabel={(option) => option.grade || ''}
                                value={hrSimulationOfficialGradeData.find(
                                    (el) => el.grade === grade,
                                )}
                                onChange={(_, newValue) => {
                                    onGradeChange(newValue?.grade || '');
                                    onEchelonChange('');
                                    onChanges(!!newValue);
                                }}
                                sx={{
                                    backgroundColor: 'white',
                                    width: '100%',
                                    marginTop: '5px',
                                }}
                                disabled={!isUpdateEnabled}
                                renderInput={(params) => (
                                    <TextField {...params} />
                                )}
                            />
                        )}
                    </Box>
                </Grid>
            </Grid>
        </StyBlock>
    );
};

export default GradeSelect;
